import React, { Component } from "react";
import { TextField as MaterialTextField } from "@mui/material";

export class TextField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.value != this.props.value) {
            this.setState({ value: this.props.value });
        }
    }

    render() {
        const { value: propValue, onChange, onBlur, onKeyDown, onEnterKeyPress, multiline, warning: _warning, ...rest } = this.props;
        const { value } = this.state;

        return (
            <MaterialTextField
                {...rest}
                value={value}
                multiline={multiline}
                onKeyDown={event => {
                    event.stopPropagation();
                    if (onKeyDown) {
                        onKeyDown(event);
                        return;
                    }

                    if (event.key === "Enter") {
                        if (multiline && event.shiftKey) {
                            return;
                        }

                        if (onEnterKeyPress) {
                            onEnterKeyPress(event.target.value);
                            event.preventDefault();
                        } else {
                            event.target.blur();
                        }
                    }
                }}
                onBlur={event => {
                    onBlur && onBlur(event.target.value);
                }}
                onChange={event => {
                    this.setState({ value: event.target.value });
                    onChange && onChange(event.target.value);
                }}
            />
        );
    }
}
